<template>
  <qc-container title="帮助中心" >
    <page-request ref="table" url="/api/mgr/business/content/help/list" :table-header="tableHeader" :expend="expend" :op-width="200">
      <t-button  @click="doEdit()">添加</t-button>
      <t-button @click="batchDel">批量删除</t-button>
      <template #op="scope">
        <b-button  @click="doEdit(scope.row)">编辑</b-button>
        <b-button  @click="doDel([scope.row.id])">删除</b-button>
      </template>
    </page-request>
    <HelpAdd ref="add" @load="pageReloadData"></HelpAdd>
  </qc-container>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container";
import PageRequest from "/src/components/base/page-request";
import TButton from "/src/components/el/t-button";
import BButton from "/src/components/el/b-button";
import HelpAdd from "./op/help-add";


export default {
  name: 'help_list',
  components: {QcContainer, PageRequest,TButton,BButton,HelpAdd},
  data () {
    return {
      tableHeader: [
        {type: "selection", label: ""},
        {prop: "title", label: "标题"},
        {prop: "createTime", label: "创建时间",width:160},
      ],
      expend:[
        {label: "标题", prop: "title"},
        {label: "创建时间", start: "createTimeStart", end: "createTimeEnd", type: "daterange"},
      ],
    }
  },
  mixins: [tableBase],
  methods: {
    doEdit(row){
      this.$refs.add.open(row);
    },
    doDel(ids){
      this.msgConfirm("/api/mgr/business/content/help/delete",{ids:ids},()=>{
        this.pageReloadData();
      });
    },
    batchDel(){
      let list = this.$refs.table.getSelectionRows();
      if(list&&list.length>0){
        let ids = list.map(item=>item.id);
        this.doDel(ids);
      }else{
        this.messageError("请勾选要操作的对象");
      }
    }
  },
  mounted () {

  }
}
</script>


<style lang="less" scoped>

</style>
